import ContentModel from '../../../../model/contentModel'
import AppStateModel from '../../../../model/appStateModel';
import RegionalComparisonModel from '../../model/regionalComparisonModel';
import MainController from '../../../../controller/MainController';
import ViewportUtility from '@/core/utils/viewport/viewportUtil';
import EventDispatcher from '@/core/event/eventDispatcher';
import ViewportEvent from '@/core/utils/viewport/viewportEvents';
import DomUtil from './../../../../../core/utils/domUtil';
import HelperUtil from './../../../../../core/utils/helperUtil';
import LogUtil from './../../../../../core/utils/logUtil';
import styles from './regional.module.scss';
import template from './regional.tpl';
import {gsap} from 'gsap';
import map from '@/assets/icons/deutschland_map.svg?raw';

// dropdown template
import ddTemplate from './../../../../../app/components/templates/dropdown/dropdown.tpl';
import ddStyles from '@/app/components/templates/dropdown/dropdown.module.scss';
import arrow from '@/assets/icons/dropdown-grey.svg?raw';

// gender template
import gTemplate from '@/app/components/templates/genderselection/genderselection.tpl';
import gStyles from '@/app/components/templates/genderselection/genderselection.module.scss';


// let yearHandler: (event:Event) => void | null = null;
// let genderHandler:(event:Event) => void | null = null;
// let regionHandler:(event:Event) => void | null = null;

const _HOVER_CLASS = 'hover';

export default class Regional {

    public _id = 'regional';
    private target: HTMLElement|null = null;
    private data: any;
    private common: any;
    private template: string;
    private map: HTMLElement|null = null;
    private map_east: NodeListOf<HTMLElement>|null = null;
    private bar_charts: HTMLElement|null = null;
    private selection: HTMLElement|null = null;
    private gender_selection: HTMLElement|null = null;
    private results_wrapper: HTMLElement|null = null;
    private female_select: HTMLElement|null = null;
    private male_select: HTMLElement|null = null;
    private map_value: HTMLElement|null = null;


    constructor(data) {

        this.data = data;
        this.common = ContentModel.instance.getCommonData();
        this.template = template({
            data: data,
            styles: styles,
            default: this.common.defaults.input,
            svg: {
                map: map,
            },
            dropdown: ddTemplate({
                styles: ddStyles,
                icon: arrow,
                options: HelperUtil.getInterval(this.common.limits.birthyear.min_year, this.common.limits.birthyear.max_year),
                default: this.common.defaults.input
            }),
            gender_selection: gTemplate({
                styles: gStyles,
                data: this.common.gender
            }),
        });


       // yearHandler = (event) => this.yearInput(event);
       // genderHandler = (event) => this.genderInput(event);
       /* regionHandler = (event) => {
            // For this SVG / Bar-chart sync to work, we rely on both sides to have matching data-targets (region name).
            // This was manually added to the SVG, and generated for the graphs (template twig).
            if (event.type === 'mouseover') {
                const target: Element = event.target as Element;
                if (target) {
                    this.highlightPath(target.getAttributeNode('data-target')?.value);
                    this.dimGraphs(target.getAttributeNode('data-target')?.value);
                    this.setMapValue(target.getAttributeNode('data-target')?.value);
                }

            }
            else if (event.type === 'mouseout') {
                const target: Element = event.target as Element;
                if (target) {
                    this.dimPath(target.getAttributeNode('data-target')?.value);
                    this.highlightGraphs(target.getAttributeNode('data-target')?.value);
                }
                this.setMapValue();
            }
        };
        */


        EventDispatcher.addEventListener(ViewportEvent.BREAKPOINT_CHANGE, (event) => this.breakPointChange(event));
    }

    breakPointChange(event) {
        event;
        // react on change if needed
    }

    genderInput(event) {

        AppStateModel.gender = event.target.attributes['data-gender'].value;

        this.update();
    }

    yearInput(event) {

        if (event.target.value !== this.common.defaults.input) {

            AppStateModel.birthday = event.target.value;

            this.update();
        }
    }

    updateGenderButtons() {

        if(this.male_select && this.female_select && this.results_wrapper) {
            if (AppStateModel.gender === 'm') {
                DomUtil.addClass(this.male_select, 'active');
                DomUtil.removeClass(this.female_select, 'active');
                DomUtil.addClass(this.results_wrapper, 'male');
                DomUtil.removeClass(this.results_wrapper, 'female');
            }
            else {
                DomUtil.addClass(this.female_select, 'active');
                DomUtil.removeClass(this.male_select, 'active');
                DomUtil.addClass(this.results_wrapper, 'female');
                DomUtil.removeClass(this.results_wrapper, 'male');
            }
        }
    }

    update() {

        if (AppStateModel.gender) {

            this.updateGenderButtons();
        }
        if (AppStateModel.gender && AppStateModel.birthday) {

           // this.setChartValues(RegionalComparisonModel.getResultsByYear().region);

            // enable sharing for this view/step when values are present
            MainController.setSharing(true);
        }
    }

    animateChart(target, value, multiplier = 2.8, correction = -112) {

        let wTo = Math.round(value * multiplier) + correction;

        gsap.fromTo(target, {
            duration: 0.5,
            width: 10
        }, {
            width: wTo
        })

    }

    show(timeline, previousStep) {

        let timelineGroup = [
            gsap.from(['.step > h1'], { duration: 0.2, autoAlpha: 0, y: -20}),
            gsap.from(this.bar_charts, { duration: 0.2, x: 200, autoAlpha: 0})
            // adding tween animations here depending on which step comes next.
        ];

        // only add detail animations if we are above mobile widths.
        if (ViewportUtility.width >= 1024) {
            switch (previousStep) {

                case 'eastwest':
                    timelineGroup.push(gsap.from(this.gender_selection, 0.2, {x: -150}));
                    break;

                case 'index':
                    timelineGroup.push(gsap.from(this.selection, 0.2, {x: -150}));
                    break;

                default:
                    break;
            }
        }

        timeline.add(timelineGroup);
    }

    hide(timeline, nextStep, onComplete) {

        let timelineGroup = [
            gsap.to(['.step > h1', '.legend'], 0.2, {autoAlpha: 0, onComplete: onComplete})
            // adding tween animations here depending on which step comes next.
        ];

        // only add detail animations if we are above mobile widths.
        if (ViewportUtility.width >= 1024) {
            switch (nextStep) {

                case 'eastwest':
                    timelineGroup.push(gsap.to(this.gender_selection, 0.2, {x: -200}));
                    timelineGroup.push(gsap.to(this.bar_charts, 0.2, {x: 200, autoAlpha: 0}));
                    timelineGroup.push(gsap.to(this.map_east, 0.2, {fill: '#6b7173'}));
                    timelineGroup.push(gsap.to(this.map, 0.2, {
                        x: 78,
                        y: 18,
                        width: 322,
                        height: 430
                    }));
                    break;

                case 'index':
                    LogUtil.warn('No animation for transition, fall back to default');
                // TODO, if we can navigate back to index from within this step we should add animations for that.
                //break;

                default: // eslint-disable-line
                    // currently without fallback default. Instantly show.
                    break;
            }
        }

        timeline.add(timelineGroup);
    }

    appendTo(target:HTMLElement|null = null) {

        if (!target) {
            return
        }
        this.target = target;
        this.target.setAttribute('id', this.data.steps.regional.id);
        this.target.innerHTML = this.template;

        // Collect DOM references

        // used by animations AND gender styling
        this.map = this.target.querySelector('.map');
        this.map_east = this.target.querySelectorAll('#Thüringen, #Sachsen, #Sachsen-Anhalt, #Brandenburg, #Berlin, #Mecklenburg-Vorpommern'); // only for animation purposes (fill)
        this.bar_charts = this.target.querySelector('.bar_charts');
        this.selection = this.target.querySelector('div.selection');
        this.gender_selection = this.target.querySelector('div.gender_selection');


        // needed for functionality
        this.results_wrapper = this.target.querySelector('.results_wrapper');
        this.female_select = this.target.querySelector('#female_select');
        this.male_select = this.target.querySelector('#male_select');

        this.map_value = this.target.querySelector('.map_value');


    }
}
